var map = {
	"./bulk-sms/bulk-sms.module": [
		"./src/app/layout/bulk-sms/bulk-sms.module.ts",
		"default~bulk-sms-bulk-sms-module~dashboard-dashboard-module~login-login-module~promotional-sms-promo~3191c55d",
		"default~bulk-sms-bulk-sms-module~promotional-sms-promotional-sms-module~transactional-sms-transactio~7afe71e4",
		"common",
		"bulk-sms-bulk-sms-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/layout/dashboard/dashboard.module.ts",
		"default~bulk-sms-bulk-sms-module~dashboard-dashboard-module~login-login-module~promotional-sms-promo~3191c55d",
		"common",
		"dashboard-dashboard-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"layout-layout-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"default~bulk-sms-bulk-sms-module~dashboard-dashboard-module~login-login-module~promotional-sms-promo~3191c55d",
		"common",
		"login-login-module"
	],
	"./promotional-sms/promotional-sms.module": [
		"./src/app/layout/promotional-sms/promotional-sms.module.ts",
		"default~bulk-sms-bulk-sms-module~dashboard-dashboard-module~login-login-module~promotional-sms-promo~3191c55d",
		"default~bulk-sms-bulk-sms-module~promotional-sms-promotional-sms-module~transactional-sms-transactio~7afe71e4",
		"common",
		"promotional-sms-promotional-sms-module"
	],
	"./register/register.module": [
		"./src/app/register/register.module.ts",
		"common",
		"register-register-module"
	],
	"./single-sms/single-sms.module": [
		"./src/app/layout/single-sms/single-sms.module.ts",
		"default~bulk-sms-bulk-sms-module~dashboard-dashboard-module~login-login-module~promotional-sms-promo~3191c55d",
		"common",
		"single-sms-single-sms-module"
	],
	"./transactional-sms/transactional-sms.module": [
		"./src/app/layout/transactional-sms/transactional-sms.module.ts",
		"default~bulk-sms-bulk-sms-module~dashboard-dashboard-module~login-login-module~promotional-sms-promo~3191c55d",
		"default~bulk-sms-bulk-sms-module~promotional-sms-promotional-sms-module~transactional-sms-transactio~7afe71e4",
		"common",
		"transactional-sms-transactional-sms-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;